import React, { Suspense, lazy } from 'react';
import { PageLoadError, PageLoading } from '../../../layouts/PageStates';

/**
 * The redesigned account page for a URL whose legacy page stays for SLOT_MODEL off (the
 * legacy file renders `flag('SLOT_MODEL') ? <Lazy /> : <Legacy />`): loaded on demand, with
 * its own Suspense (the bare PortalLayout routes have none; under PublicLayout it simply
 * nests) and PageLoadError when the chunk cannot be fetched. Kept apart from AccountLayout so
 * only this helper is in the main bundle. `displayName` = `name`.
 */
export default function lazyAccountPage(name, load) {
  const Page = lazy(() => load().catch(() => ({ default: PageLoadError })));
  const Lazy = (props) => (
    <Suspense fallback={<PageLoading />}>
      <Page {...props} />
    </Suspense>
  );
  Lazy.displayName = name;
  return Lazy;
}
